import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo);
  }

  handleReload = () => {
    this.setState({ hasError: false, error: null });
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50 p-6">
          <div className="max-w-md bg-white border border-gray-200 rounded-md p-6 shadow-sm" translate="no">
            <h2 className="text-xl font-bold text-gray-900 mb-2">
              Что-то пошло не так
            </h2>
            <p className="text-sm text-gray-600 mb-4">
              Скорее всего у вас включён Google Translate в браузере. Пожалуйста, отключите его для этого сайта.
            </p>
            <p className="text-xs text-gray-500 mb-4 font-mono bg-gray-50 p-2 rounded">
              {this.state.error?.message || 'Unknown error'}
            </p>
            <button
              onClick={this.handleReload}
              className="w-full bg-[#1A1A1A] hover:bg-black text-white py-2 px-4 rounded-md font-medium"
              data-testid="reload-btn"
            >
              Перезагрузить
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
